module.exports = require("botpress-version-manager");


//////////////////
// WEBPACK FOOTER
// external "botpress-version-manager"
// module id = 7
// module chunks = 0